import {
  Field,
  Label,
  Description,
  Input as BaseInput,
  InputProps as BaseInputProps,
} from '@headlessui/react';
import { twMerge } from 'tailwind-merge';

type InputProps = BaseInputProps & {
  label?: string;
  description?: string;
  wrapperClassName?: string;
  fieldClassName?: string;
  className?: string;
};

export default function Input({
  label,
  description,
  wrapperClassName,
  fieldClassName,
  className,
  ...other
}: InputProps) {
  return (
    <div className={twMerge(['w-full max-w-md', wrapperClassName])}>
      <Field
        className={twMerge([
          'flex flex-col items-start justify-center gap-1',
          fieldClassName,
        ])}
      >
        {label && <Label className="text-sm font-medium">{label}</Label>}
        {description && (
          <Description className="text-sm">{description}</Description>
        )}
        <BaseInput
          className={twMerge([
            'block w-full rounded-sm border px-1 py-0.5 text-sm',
            'focus:outline-none data-[focus]:outline-1 data-[focus]:-outline-offset-2 data-[focus]:outline-white/25',
            className,
          ])}
          {...other}
        />
      </Field>
    </div>
  );
}
